
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientionwarmingblanket() {



  const cardData =
  {
    keyword: 'Patient Warming Blanket',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming Blanket',
    headingDescription: 'Pharmacle Health Care Private Limited provides top-quality Patient Warming Blanket solutions in Kolkata to ensure safe and effective temperature management during surgeries and recovery. Our advanced warming blankets help prevent hypothermia by delivering gentle, consistent heat to patients, promoting faster healing and enhanced comfort. Trusted by leading hospitals and healthcare institutions, our patient warming blankets are easy to use, reliable, and crafted with state-of-the-art technology. Choose Pharmacle Health Care for superior warming blankets in Kolkata that prioritize patient safety and clinical excellence.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Advanced Patient Warming Blanket for Superior Thermal Care",
    "description": "Pharmacle Health Care provides high-quality patient warming blankets designed to maintain body temperature during surgeries and post-operative care. Ideal for preventing hypothermia and ensuring patient comfort."
  },
  {
    "title": "Best Patient Warming Blankets for Hospitals and Recovery Units",
    "description": "Our warming blankets offer reliable thermal support for surgical rooms, ICUs, and emergency units. Engineered for safe and effective temperature regulation during medical treatments."
  },
  {
    "title": "Reliable Patient Warming Blanket for Comfortable Healing",
    "description": "Ensure a warm and stable recovery environment with Pharmacle Health Care’s dependable patient warming blankets. Widely trusted by medical professionals for consistent performance."
  },
  {
    "title": "High-Quality Patient Warming Blankets for Clinical Use",
    "description": "Our blankets are crafted from soft, medical-grade materials that ensure even heat distribution, reducing risks associated with perioperative hypothermia in patients."
  },
  {
    "title": "Buy Patient Warming Blanket for Enhanced Patient Recovery",
    "description": "Pharmacle Health Care offers top-rated warming blankets suitable for neonatal care, general surgery, and trauma cases. Improve patient outcomes with our advanced warming solutions."
  },
  {
    "title": "Innovative Patient Warming Blanket for Efficient Temperature Control",
    "description": "Utilizing modern thermal technology, our warming blankets provide consistent warmth and are easy to use in clinical environments, making them a must-have for medical teams."
  },
  {
    "title": "Affordable and Durable Patient Warming Blankets",
    "description": "Pharmacle Health Care delivers cost-effective warming blanket solutions without compromising on quality. Ideal for regular hospital usage with long-lasting performance."
  },
  {
    "title": "Trusted Supplier of Patient Warming Blankets",
    "description": "Leading healthcare facilities rely on our warming blankets for safe and efficient thermal care. Pharmacle Health Care is known for quality, reliability, and professional service."
  },
  {
    "title": "Pediatric and Adult Patient Warming Blankets",
    "description": "Our warming blankets cater to both pediatric and adult patients, ensuring targeted thermal support tailored to individual needs during medical procedures."
  },
  {
    "title": "Hospital-Grade Patient Warming Blanket for Optimal Care",
    "description": "Provide patients with superior thermal protection during surgery and recovery. Pharmacle Health Care’s warming blankets are trusted by healthcare providers for excellent clinical results."
  }
],

   "services": [
    {
      "name": "Patient Warming Blanket",
      "description": "Pharmacle Health Care offers patient warming blankets designed to maintain body temperature during medical procedures. These blankets help prevent hypothermia and provide comfort and safety in clinical environments."
    },
    {
      "name": "Surgical Warming Blankets",
      "description": "Our surgical warming blankets are engineered for use during operations to ensure patients remain normothermic. These blankets enhance surgical outcomes by minimizing temperature-related complications."
    },
    {
      "name": "Medical Thermal Blanket",
      "description": "Pharmacle Health Care provides medical thermal blankets that deliver consistent heat to patients during treatment. Ideal for a variety of medical settings, these blankets support safe and effective temperature management."
    },
    {
      "name": "Operating Room Warming Blanket",
      "description": "We supply operating room warming blankets that ensure temperature stability throughout surgical procedures. These blankets are critical in maintaining patient body heat in highly controlled surgical environments."
    },
    {
      "name": "Heated Patient Blankets",
      "description": "Our heated patient blankets are designed to offer adjustable thermal support during medical treatment and recovery. They are essential for preventing hypothermia and ensuring patient comfort."
    },
    {
      "name": "Hospital Thermoregulation Blankets",
      "description": "Pharmacle Health Care offers hospital thermoregulation blankets designed for efficient heat distribution in clinical care. These blankets help in maintaining normothermia during preoperative, intraoperative, and postoperative stages."
    },
    {
      "name": "Perioperative Patient Warming Blanket",
      "description": "We provide perioperative patient warming blankets that support comprehensive temperature management before, during, and after surgery. These blankets contribute to improved patient safety and faster recovery."
    }
  ],
  "tableData": [
    ["- Patient Warming Blanket", "- Surgical Warming Blankets"],
    ["- Medical Thermal Blanket", "- Operating Room Warming Blanket"],
    ["- Heated Patient Blankets", "- Hospital Thermoregulation Blankets"],
    ["- Perioperative Patient Warming Blanket"]
  ],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced Patient Warming Blankets in Kolkata, designed to deliver precise and consistent temperature control during medical procedures. Our technology helps prevent hypothermia and supports optimal patient outcomes."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "Our Patient Warming Blankets are part of a complete range of warming solutions in Kolkata, suitable for surgical, post-operative, and critical care use. We offer options tailored to various medical environments to enhance patient comfort and safety."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Manufactured to the highest standards, our Patient Warming Blankets are durable, dependable, and built for repeated use in clinical settings. Each blanket is tested for quality assurance to deliver long-lasting performance in hospitals and clinics across Kolkata."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Designed with patient comfort in mind, our Patient Warming Blankets provide gentle and controlled heat to reduce the risk of temperature-related complications. They ensure a comfortable experience for patients undergoing various medical procedures in Kolkata."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our Patient Warming Blankets in Kolkata are compatible with different healthcare settings, from general wards to surgical theaters. We work with medical teams to offer the right solutions that meet their operational and patient care needs."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s Patient Warming Blankets are designed for easy integration with existing warming systems in Kolkata. They can be quickly deployed with minimal training and without disrupting clinical workflows."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert guidance to help healthcare providers in Kolkata select the most effective Patient Warming Blankets for their specific requirements. Ongoing support and maintenance services are also available to ensure consistent performance."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, we prioritize patient safety and comfort. Our Patient Warming Blankets are engineered to maintain safe body temperatures during surgeries and recovery, ensuring every patient in Kolkata receives the best possible care."
    }
]
























  }

const faqData = [
  {
    question: "What is a Patient Warming Blanket?",
    answer: "A Patient Warming Blanket is a specialized medical blanket used to maintain or raise a patient’s body temperature during surgery or recovery. It connects to a warming system that circulates warm air or fluid to keep the patient comfortably warm."
  },
  {
    question: "How does a Patient Warming Blanket work?",
    answer: "The blanket is connected to a warming unit that delivers controlled heat. The warm air or fluid flows through the blanket, evenly distributing heat across the patient's body to prevent hypothermia during medical procedures."
  },
  {
    question: "Is the Patient Warming Blanket available in Kolkata?",
    answer: "Yes, Pharmacle Health Care Private Limited provides high-quality Patient Warming Blankets to hospitals and clinics in Kolkata, ensuring effective temperature management during medical treatments."
  },
  {
    question: "Can the Patient Warming Blanket be reused?",
    answer: "Pharmacle Health Care offers both reusable and disposable options depending on clinical needs. Reusable blankets can be sanitized and used multiple times, while disposable ones are for single use to ensure hygiene."
  },
  {
    question: "Is the Patient Warming Blanket safe for all patients?",
    answer: "Yes, when used under professional supervision, the Patient Warming Blanket is safe for most patients. It helps avoid both underheating and overheating through adjustable temperature settings."
  },
  {
    question: "How can I order a Patient Warming Blanket in Kolkata?",
    answer: "To order, contact Pharmacle Health Care Private Limited. Our team will assist you with product selection and delivery of Patient Warming Blankets to your healthcare facility in Kolkata."
  }
];

const testimonialsData = [
  {
    text: "The Patient Warming Blanket from Pharmacle Health Care has significantly improved the quality of care in our surgical unit. It helps maintain patient temperature and adds an extra layer of comfort during procedures.",
    name: "Dr. Arindam Roy"
  },
  {
    text: "Pharmacle Health Care’s Patient Warming Blankets are reliable and effective. We’ve integrated them into our standard operating room protocol to enhance patient safety during surgery.",
    name: "Greenview Hospital, Kolkata"
  }
];



  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



 
  const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Patient Warming Blanket",
  "description": "Find high-quality Patient Warming Blankets for effective thermal regulation during surgeries and postoperative care. Our blankets provide safe and comfortable warmth to ensure optimal patient thermoregulation.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5154"
  }
};



  

  return (
    <div>
  
<Helmet>
  <title>Patient Warming Blanket | Contact: +91 8956322311</title>
  <meta
    name="description"
    content="Find Patient Warming Blankets designed for safe and comfortable thermal regulation during surgeries. Contact us at +91 8956322311."
  />
  <meta
    name="keywords"
    content="Patient Warming Blanket, Surgical Warming Blankets, Medical Thermal Blanket, Operating Room Warming Blanket, Heated Patient Blankets, Hospital Thermoregulation Blankets, Perioperative Patient Warming Blanket"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/61.png' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Navar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientionwarmingblanket;